import * as types from './assetTypes';

export const INTERNAL_TRANSFERS_FORM = 'internalTransfers';
export const TRANSFER_FROM_ACCOUNT = 'fromAccount';

export const INTERNAL_TRANSFER_ASSET_TYPES = [types.USD];
